import { SOH_TOOL } from "../../types";

const SOHTool = (state = {}, action) => {
    if (action.type === SOH_TOOL)
        return action.payload;
    return state;
};
export default SOHTool;